/**
 * Leaf selector for spoofed/staff-session detection.
 * Kept out of featuresSelectors so payment/cruise selectors can use it without
 * pulling getCheckoutTotalsView (and the cruiseSelectors cycle) via featuresSelectors.
 */
export const isSpoofed = (state: App.State) => state.auth.account.isSpoofed
